import Icon from '@passkeys/ui/icon';
import Text from '@passkeys/ui/text';

import { cn } from '@/ui/utils/classnames';

interface FilterProps {
  value: string;
  onClick: () => void;
  className?: string;
  dataTestId?: string;
}

function Filter({ value, onClick, className, dataTestId }: FilterProps) {
  return (
    <button
      className={cn(
        'relative isolate flex h-12 items-center gap-x-2 rounded-[12px] px-3 shadow-sm *:z-[1] theme-dark:shadow-none',
        'bg-gray-100 theme-dark:bg-neutral-600',
        'before:absolute before:inset-0 before:rounded-[12px] before:bg-gradient-to-b before:from-black/6 before:to-black/6 theme-dark:before:from-[#303033]/20 theme-dark:before:to-[#37373b]/60',
        'after:absolute after:inset-px after:rounded-[11px] after:bg-gray-100 theme-dark:after:bg-neutral-600',
        className,
      )}
      onClick={onClick}
      type="button"
      data-testid={dataTestId}
    >
      <Text
        className="min-w-0 flex-1 truncate text-gray-500 theme-dark:text-neutral-100"
        size={14}
      >
        {value}
      </Text>
      <Icon
        className="text-gray-400 theme-dark:text-neutral-200"
        name="triangle-down"
        size={24}
      />
    </button>
  );
}

export default Filter;
